import { render, staticRenderFns } from "./AnnotoriousRenderer.vue?vue&type=template&id=fbcbabe0&scoped=true"
import script from "./AnnotoriousRenderer.vue?vue&type=script&lang=js"
export * from "./AnnotoriousRenderer.vue?vue&type=script&lang=js"
import style0 from "./AnnotoriousRenderer.vue?vue&type=style&index=0&id=fbcbabe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcbabe0",
  null
  
)

export default component.exports